/* globals angular, _ */
(function() {
  'use strict';

  function ReversesOriginCtrl (
    mdPanelRef,
    $controller,
    moment,
    Historico,
    localStorageService
  ) {

    angular.extend(this, $controller('BasePanelCtrl', {}));

    var $ctrl = this;

    $ctrl.config = {
      loading: {
        panel: true
      }
    };

    function _fetchDetails () {
      $ctrl.config.msgError = false;

      Historico
        .getReverseOrigin($ctrl.id)
        .then(function(details) {
          $ctrl.enableDisableLoading($ctrl.config.loading, 'panel', null);
          $ctrl.origin = details;
        })
        .catch(function() {
          $ctrl.enableDisableLoading($ctrl.config.loading, 'panel', null);
          $ctrl.config.msgError = true;
        });
    }

    _fetchDetails();

    $ctrl.closePanel = function () {
      $ctrl.close(mdPanelRef);
    };
  }

  angular
    .module('mandaeApp')
    .controller('ReversesOriginCtrl', ReversesOriginCtrl);
}());
